export const ACCESS_TOKEN_KEY = 'AccessToken';
export const REFRESH_TOKEN_KEY = 'RefreshToken';
